import { useMemo } from 'react';
import { useInventoryQuery } from './inventoryItem.generated';

const useGetInventoryItem = (
  inventoryId: string | undefined,
  retailerId?: string,
) => {
  const [{ data, fetching }] = useInventoryQuery({
    variables: {
      inventoryId: inventoryId || '',
      retailerId: retailerId || '',
    },
    pause: !inventoryId || !retailerId,
  });

  const inventoryItemWithPrice = useMemo(() => {
    if (!data?.inventory || !data.currentUser?.prices) return null;

    const {
      inventory,
      currentUser: { prices },
    } = data;

    // Find the customerPrice for the article in articleData
    const customerPrice = prices.find(
      (price) => price.articleID === inventory.articleData?.id,
    );

    // Extend articleData with customerPrice
    const extendedArticleData = {
      ...inventory.articleData,
      customerPrice,
    };

    return {
      ...inventory,
      articleData: extendedArticleData,
    };
  }, [data]);

  return { inventoryItem: inventoryItemWithPrice, fetching };
};

export default useGetInventoryItem;
